// src\pages\Parts\PartsPage.tsx

export const PartsPage = () => {
    return (
        <div className="">
            PartsPage
        </div>
    )
}

export default PartsPage